import {styled} from '@mui/material';

const isMediumScreen = window.innerWidth <= 1400;
export const Container = styled('div')`
    display: flex;
    justify-content: space-around;
    align-items: center;
    ${ isMediumScreen && 'overflow: scroll'};
`;
